import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import SearchBar from "shared/SearchBar";
import AssignedAudioRow from "DreamCast/Shared/AssignedAudioRow";
import styles from "./MediaUsedOnSection.module.css";

export function MediaUsedOnSection({ media, onEdit }) {
  const [searchTerm, setSearchTerm] = useState("");
  const visibleMedia = useMemo(() => {
    const query = searchTerm.trim().toLowerCase();
    if (!query) return media;
    return media.filter((item) =>
      `${item.title} ${item.sku || ""} ${item.type || ""} ${
        item.speaker || ""
      } ${item.episodePart || ""}`
        .toLowerCase()
        .includes(query),
    );
  }, [media, searchTerm]);

  return (
    <section className={styles.card}>
      <div className={styles.headerRow}>
        <h3 className={styles.heading}>Media Used On</h3>
        <div className={styles.searchWrap}>
          <SearchBar
            placeholderText="Search Media"
            value={searchTerm}
            onInput={setSearchTerm}
            minChar={0}
            searchDelay={0}
          />
        </div>
      </div>
      <div className={styles.divider} />

      {media.length === 0 ? (
        <p className={styles.emptyState}>Not Currently Used on Media</p>
      ) : visibleMedia.length === 0 ? (
        <p className={styles.emptyState}>No Matching Media</p>
      ) : (
        <ul className={styles.list} aria-label="Media using this disclosure">
          {visibleMedia.map((item) => (
            <li key={item.id} className={styles.mediaRow}>
              <AssignedAudioRow
                thumbnail={item.thumbnail}
                title={item.title}
                date={item.date}
                speaker={item.speaker}
                episodePart={item.episodePart}
                showRemove={false}
                draggable={false}
                onEdit={() => onEdit(item)}
              />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

MediaUsedOnSection.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      sku: PropTypes.string,
      type: PropTypes.string,
      thumbnail: PropTypes.string.isRequired,
      date: PropTypes.string,
      speaker: PropTypes.string,
      episodePart: PropTypes.string,
    }),
  ),
  onEdit: PropTypes.func,
};

MediaUsedOnSection.defaultProps = {
  media: [],
  onEdit: () => {},
};

export default MediaUsedOnSection;
